module.exports = __webpack_public_path__ + "static/media/send.0458bf90.svg";